import methods from '@/services/methods'

export default {
  listRoles () {
    return methods.sendGet(`roles`, null, {unprivilege: 'Settings', noHyptoLoader: true})
  },
  roleDetails (id) {
    return methods.sendGet(`roles/${id}`, null, {unprivilege: 'RoleDetails'})
  },
  createRole (payload) {
    return methods.sendPost(`roles`, payload)
  },
  updateRole (id, payload) {
    return methods.sendPut(`roles/${id}`, payload)
  },
  destroyRole (id) {
    return methods.sendDelete(`roles/${id}`)
  },
  newRoleAccess () {
    return methods.sendGet(`roles/new`, null, {unprivilege: 'RoleDetails'})
  }
}
